import React from 'react';
import { useSelector } from 'react-redux';
import { path } from 'js/utils/ramda.util';
import { useLocation } from 'react-router-dom';
import Overlay from 'js/components/common/Overlay';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { MY_ACCOUNT_SIDEBAR_REDUCER } from 'js/store/constants';
import { useCallbackOnLogout } from 'js/hooks/useCallbackOnLogout';

import * as hooks from './hooks';
import { Header } from './components/Header';
import { Content } from './components/Content';

import style from './MyAccountSidebar.scss';

export const MyAccountSidebar = () => {
    const location = useLocation();
    const handleSidebarClose = hooks.useHandleSidebarClose();
    const isOpened = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'isOpened']));
    const sidebarPosition = useSelector(path([MY_ACCOUNT_SIDEBAR_REDUCER, 'sidebarPosition']));
    const isOpenedClass = isOpened ? style.opened : '';

    useUpdateEffect(() => {
        handleSidebarClose();
    }, [location.pathname, handleSidebarClose]);

    useCallbackOnLogout(handleSidebarClose);

    return (
        <>
            <div className={`${style.sidebar} ${isOpenedClass} ${style[sidebarPosition]}`}>
                {isOpened && (
                    <>
                        <Header/>
                        <Content/>
                    </>
                )}
            </div>
            {isOpened && (
                <Overlay
                    className={style.overlay}
                    onClick={handleSidebarClose}
                />
            )}
        </>
    );
};
